import L from 'leaflet';
import { isEmpty, forEach } from 'lodash';

const LINE_STYLE = {
  color: '#337ab7',
  weight: 5,
  opacity: 0.65
};

/**
 * Draws the lines drawn on the video in the map.
 *
 * @param {object} arg - The object argument.
 * @param {object} arg.leafletMap - The leaflet map object.
 * @param {object[]} arg.lines - The lines drawn on the video.
 * @param {?object} arg.linesLayer - The geoJSON layer where the lines will be painted.
 * @param {boolean} [arg.isUpdate=false] - Flag to determine if we are doing an update.
 * @returns {object} The leaflet layer where the lines are painted.
 */
const drawVideoLines = ({ leafletMap, lines, linesLayer, isUpdate = false }) => {
  let newLinesLayerContainer = '';
  if (!isUpdate) {
    newLinesLayerContainer = L.geoJSON().addTo(leafletMap);
  } else {
    newLinesLayerContainer = linesLayer;
    newLinesLayerContainer.clearLayers();
  }
  if (!isEmpty(lines)) {
    forEach(lines, line => {
      const myLinesLayer = L.geoJSON(line, { style: LINE_STYLE });
      newLinesLayerContainer.addLayer(myLinesLayer.getLayers()[0]);
    });
  }
  return newLinesLayerContainer;
};
export default drawVideoLines;
